import { Inject } from "inversify-props";
import type { PromocaoServiceAdapter } from "./adapter/PromocaoServiceAdapter";
import { Promocao } from "@/models";

export class SavePromocaoUseCase{
	@Inject('PromocaoServiceAdapter')
		private promocaoServiceAdapter!: PromocaoServiceAdapter

		criarPromocao = async (promocao: Promocao): Promise<Promocao> =>
			await this.promocaoServiceAdapter.criarPromocao(promocao)

		atualizarPromocao = async (promocao: Promocao): Promise<Promocao> =>
			await this.promocaoServiceAdapter.atualizarPromocao(promocao)

		atualizaRelacaoVendaPromocao = async (params: any): Promise<void> =>
			await this.promocaoServiceAdapter.atualizaRelacaoVendaPromocao(params)
}